import { useState } from "react";
import TextField from "./TextField";
import MuiAutoComplete from "@mui/material/Autocomplete";
import { get } from "lodash";

export default function Autocomplete({
  label,
  name,
  defaults,
  options = [],
  formikProps,
  placeholder,
  required,
  ...props
}) {
  // local state for text search value
  const [inputValue, setInputValue] = useState("");

  const currentValue = get(formikProps.values, name, "");
  const selectedOption = options.find(
    (option) => option[defaults.primaryKey] === currentValue
  );

  return (
    <MuiAutoComplete
      freeSolo
      fullWidth
      required
      size="small"
      forcePopupIcon={true}
      options={options}
      value={selectedOption || null}
      inputValue={inputValue}
      onInputChange={(_, newInputValue) => setInputValue(newInputValue)}
      getOptionLabel={(option) =>
        typeof option === "string"
          ? option
          : get(option, defaults.displayLabel, "")
      }
      isOptionEqualToValue={(option, value) =>
        option[defaults.primaryKey] === value[defaults.primaryKey]
      }
      renderOption={(props, option) => (
        <li
          {...props}
          key={option[defaults.primaryKey]}
          style={{ fontSize: "16px", cursor: "pointer" }}
        >
          {option[defaults.displayLabel]}
        </li>
      )}
      onChange={(_, value) => {
        formikProps.setFieldValue(
          name,
          value ? value[defaults.primaryKey] : ""
        );
      }}
      {...props}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          placeholder={
            !formikProps.values[name] || formikProps.values[name] === ""
              ? placeholder
              : ""
          }
          label={label}
          name={name}
          error={Boolean(
            get(formikProps, "touched." + name) &&
              get(formikProps, "errors." + name)
          )}
          helperText={
            get(formikProps, "touched." + name) &&
            get(formikProps, "errors." + name)
          }
          onBlur={get(formikProps, "handleBlur")}
        />
      )}
    />
  );
}
